import type { Workflow } from "@/models/applications";

export const STRING_ARRAY_FILTERS = new Set([
  "additional_tracking_tokens",
  "brand_names",
  "analyst_ids",
  "client_analyst_ids",
  "client_funding_advisor_ids",
  "client_tracking_tokens",
  "client_underwriter_ids",
  "funding_advisor_ids",
  "funders_with_offers",
  "funders_with_placements",
  "last_call_by",
  "last_call_disposition",
  "last_email_sent_name",
  "master_statuses",
  "naics_codes",
  "not_additional_tracking_tokens",
  "not_analyst_ids",
  "not_client_tracking_tokens",
  "not_funding_advisor_ids",
  "not_funders_with_offers",
  "not_funders_with_placements",
  "not_origin_partners",
  "not_partners",
  "not_task_assignees",
  "not_task_priority_levels",
  "not_task_statuses",
  "not_underwriter_ids",
  "not_workflow_template_ids",
  "not_workflow_statuses",
  "not_workflow_sub_statuses",
  "number_of_employees",
  "origin_partners",
  "partners",
  "primary_owner_stated_credit_scores",
  "priorities",
  "product_type_funded",
  "not_product_type_funded",
  "products_requested",
  "referrer_host",
  "score_card_group_ids",
  "score_card_ids",
  "sources",
  "stage_categories",
  "stage_names",
  "stated_monthly_revenue",
  "submission_partners",
  "task_assignees",
  "task_priority_levels",
  "task_statuses",
  "underwriter_ids",
  "workflow_segments",
  "workflow_statuses",
  "workflow_sub_statuses",
  "workflow_template_ids",
  "latest_workflow_orchestration_log_statuses",
  "utm_parameters",
  "funded_offer_funders",
]);

export const DATE_RANGE_FILTERS = new Set([
  "application_completed_range",
  "application_started_range",
  "calls_date_range",
  "first_placement_range",
  "funded_date_range",
  "funding_term_end_date_range",
  "funding_term_start_date_range",
  "last_call_range",
  "last_email_sent_date_range",
  "last_offer_created_range",
  "last_placement_range",
  "onboarding_calls_date_range",
  "task_created_date_range",
  "task_due_date_range",
  "total_onboarding_calls_date_range",
]);

export const NUMBER_ARRAY_FILTERS = new Set([
  "actual_monthly_revenue_range",
  "amount_needed_range",
  "deal_modes",
  "deal_statuses",
  "funded_amount_range",
  "highest_offer_amount_range",
  "industry_types",
  "last_updated_offer_statuses",
  "latest_score_card_statuses",
  "number_of_calls_range",
  "number_of_onboarding_calls_range",
  "number_of_emails_received_range",
  "number_of_emails_sent_range",
  "offers_count_range",
  "placements_count_range",
  "primary_owner_actual_credit_score_range",
  "priority_offer_statuses",
  "repayment_percentage_range",
  "required_documents",
  "score_card_group_points_range",
  "score_card_points_range",
  "stage_management",
  "time_in_business_range",
  "time_in_current_stage_range",
  "time_to_first_offer_range",
  "total_number_of_onboarding_calls_range",
  "workflow_categories",
]);

export const BOOLEAN_FILTERS = new Set([
  "has_bank_data",
  "has_bank_statements",
  "has_offer",
  "has_placement",
  "has_plaid_connection",
  "is_discovery_complete",
  "is_signed",
  "task_is_created",
  "has_latest_email_validation_error",
]);

export const WORKFLOW_FILTERS: Record<string, Workflow> = {
  is_business_credit: "business_credit",
  is_data_capture: "data_capture",
  is_equipment_rental: "equipment_rental",
  is_funding: "funding",
  is_client_funded: "internal_funding",
};

export const QUERY_KEY_TO_FILTER_KEY: Record<string, string> = {
  statuses: "deal_statuses",
  created_at_range: "application_started_range",
  finished_at_range: "application_completed_range",
  number_of_calls: "number_of_calls_range",
  assigned_onboarding_calls: "number_of_onboarding_calls_range",
  created_at_call: "calls_date_range",
  created_at_assigned_onboarding_call: "onboarding_calls_date_range",
  created_at_onboarding_call: "total_onboarding_calls_date_range",
  total_onboarding_calls: "total_number_of_onboarding_calls_range",
};

export const ARRAY_BRACKET_REGEX = /\[\]$/;
